import { fetchPost, fetchGet, fetchPut, fetchDelete } from '../services/Apiservice'

export const stockUnitList = (data) => {
    return fetchGet('/stock-units', data)
        .then(res => res)
        .catch(err => { throw err })
}

export const stockUnitCreate = (data) => {
    return fetchPost('/stock-units', data)
        .then(res => res)
        .catch(err => { throw err })
}

export const stockUnitUpdate = (id, data) => {
    return fetchPut(`/stock-units/${id}`, data)
        .then(res => res)
        .catch(err => { throw err })
}

export const stockUnitDetail = (id) => {
    return fetchGet(`/stock-units/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

export const stockUnitDelete = (id) => {
    return fetchDelete(`/stock-units/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

export const stockUnitToggleStatus = (id) => {
    return fetchPost(`/stock-units/${id}/toggle-status`)
        .then(res => res)
        .catch(err => { throw err })
}